<template>
  <div class="home">
    <Tabbar :menuIndex="0" />
    <div class="top-banner">
      <div class="top-banner-title">数字勘察服务平台，深耕数字化服务</div>
      <div class="top-banner-content">让企业走在数字化前沿，实现快速发展</div>
      <div class="top-banner-btn" @click="pushApplication()">立即咨询</div>
    </div>

    <!-- <div class="bannerBox">
      <vue-seamless-scroll
        :data="bannerList"
        :class-option="optionSingleHeightTime"
        class="seamless-warp"
      >
        <div class="list">
          <div
            class="item flex"
            v-for="(item, index) in bannerList"
            :key="index"
          >
            <img :src="item.img" alt="" />
          </div>
        </div>
      </vue-seamless-scroll>
    </div> -->

    <!-- <div class="container">
      <div class="part1">
        <div class="item" v-for="(item, index) in part1List" :key="index">
          <img :src="item.img" alt="" />
          <div class="info">
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="part2">
      <div class="container container-part2">
        <img src="@/assets/ekc.png" alt="" />
        <div class="right">
          <div class="title">数字勘察服务平台</div>
          <div class="desc" style="text-align: left">
            <!-- 1. 提高勘察效率：数字勘察服务平台可以自动化勘察业务流程，减
            少人工干预，提高勘察效率。<br /><br />
            2. 提供精准数据：数字勘察服务平台可以采集、分析和查询大量数
            据，提供精准的数据支持，帮助企业做出正确的决策。 <br /><br />
            3. 提升数据可视化：数字勘察服务平台可以生成报告，将复杂数据
            可视化展示，让企业管理者更容易理解和分析数据。<br /><br />
            4. 降低成本：数字勘察服务平台可以减少人力和时间成本，提高勘
            察效率，降低企业的勘察成本。<br /><br />
            5. 增强客户体验：数字化可以帮助企业宣传业务，增强客户体验，
            提高企业的品牌知名度和美誉度。<br /><br />
            6. 提供全方位服务：数字勘察服务平台提供全方位的勘察服务，包
            括数据采集、报告生成、数据分析查询和小程序宣传，满足企业勘
            察业务的所有需求。 <br /><br />
            7. 提高决策质量：数字勘察服务平台提供精准的数据支持，帮助企
            业做出正确的决策，提高决策的质量和效果。<br /> -->
            <div class="item">
              <div class="title">勘察效率</div>
              <div class="content">
                数字勘察服务平台可以自动化勘察业务流程，减少人工干预，提高勘察效率
              </div>
            </div>
            <div class="item">
              <div class="title">数据驱动</div>
              <div class="content">
                采集、分析和查询大量数据，提供精准的数据支持，帮助企业做出正确的决策
              </div>
            </div>
            <div class="item">
              <div class="title">数据可靠</div>
              <div class="content">
                系统收录钻孔数量超过20000个，项目数量超过10000个，提供有据可查的地质数据
              </div>
            </div>
            <div class="item">
              <div class="title">可视化</div>
              <div class="content">
                生成报告，将复杂数据可视化展示，让企业管理者更容易理解和分析数据
              </div>
            </div>
            <div class="item">
              <div class="title">高效协同</div>
              <div class="content">
                数据多端同步，勘察数据及时反馈到对应人员，并快速响应分析
              </div>
            </div>
            <div class="item">
              <div class="title">降低成本</div>
              <div class="content">
                减少人力和时间成本，提高勘察效率，极大的降低企业的勘察成本。
              </div>
            </div>
            <div class="item">
              <div class="title">多维服务</div>
              <div class="content">
                包括数据采集、报告生成、数据分析查询和小程序宣传，满足企业勘察业务的所有需求
              </div>
            </div>
            <div class="item">
              <div class="title">客户体验</div>
              <div class="content">
                帮助企业宣传业务，增强客户体验，提高企业的品牌知名度和美誉度
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="part3">
        <div class="title">
          聚焦数字化服务<br />为建筑、市政、公路、铁路等领域提供全方位的服务
        </div>
        <div class="tabBox">
          <div class="tabs">
            <div
              class="tab"
              @click="part3Index = index"
              :class="{ active: part3Index == index }"
              v-for="(item, index) in part3List"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="info">
            <div class="title">{{ part3List[part3Index].info.title }}</div>
            <div class="desc">{{ part3List[part3Index].info.desc }}</div>
            <div class="btnBox">
              <div class="btn" @click="$router.push('/application')">
                方案定制
              </div>
              <div class="btn" @click="$router.push('/application')">
                了解更多
              </div>
            </div>
            <div class="typeBox">
              <div
                class="type"
                v-for="(type, index_type) in part3List[part3Index].info.type"
                :key="index_type"
              >
                {{ type }}
              </div>
              <!-- <div class="dashed"></div> -->
            </div>
            <!-- <div class="logoBox">
              <img
                class="logo"
                v-for="(logo, index_logo) in part3List[part3Index].info.logo"
                :key="index_logo"
                :src="logo"
              />
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="part4">
      <div class="container">
        <div class="title">
          准备好提升企业数字化管理水平了吗？<br />
          一站式数字化服务，就是如此简单
        </div>
        <div class="phone">咨询热线：029-83498900</div>
        <div class="input">
          <input type="text" placeholder="请输入11位手机号码" />
          <div class="appoint">免费预约</div>
        </div>
        <div class="tip">已有1565人免费预约试用</div>
      </div>
    </div> -->

    <!-- <div class="part5">
      <div class="container">
        <div class="title">客户评价 & 客户选择</div>
        <div class="sub-title">
          数字勘察服务平台已累计为<span>500+</span>企业级客户提供产品与服务
        </div>
        <div class="content">
          <div class="tabBox">
            <div class="prev" @click="cutPart5Index">
              <img src="@/assets/images/prev.png" alt="" />
            </div>
            <div class="next" @click="addPart5Index">
              <img src="@/assets/images/next.png" alt="" />
            </div>
            <div class="logoBox">
              <img :src="part5List[part5Index].img" alt="" />
            </div>
            <div class="desc">{{ part5List[part5Index].desc }}</div>
            <div class="tip">{{ part5List[part5Index].tip }}</div>
            <div class="apply btn">申请你的方案</div>
            <div class="get btn">获取更多案例</div>
          </div>
          <div class="view">
            <div
              class="item"
              v-for="(item, index) in part5List"
              :key="index"
              :style="'top:' + item.top + ';left:' + item.left"
              :class="{ active: part5Index == index }"
              @mouseover="part5Index = index"
            >
              <img
                :src="item.img"
                alt=""
                :class="{ active: part5Index == index }"
              />
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="container">
      <div class="part6">
        <div class="title">新闻资讯</div>
        <div class="newsBox">
          <div class="main-news">
            <img
              src="https://www.woqu365.com/img/main01.a738b4fa.png
"
              alt=""
            />
            <div class="title">
              喔趣科技创始人兼集团CEO储峰“入选中国人力资源服务业青年家3040榜”
            </div>
          </div>
          <div class="news-list">
            <div class="item" v-for="(item, index) in newsList" :key="index">
              <img :src="item.img" alt="" />
              <div class="info">
                <div class="title">{{ item.title }}</div>
                <div class="desc">{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <Foot />
  </div>
</template>

<script>
import Tabbar from "@/components/Nav/Nav.vue";
import Foot from "@/components/foot/Foot.vue";


export default {
  name: "Home",
  components: {
    Tabbar,
    Foot,
  },
  data() {
    return {
      bannerList: [
        {
          img: "https://www.woqu365.com/img/9.1295d05e.png",
        },
        {
          img: "https://www.woqu365.com/img/12.cb3d74c3.png",
        },
        {
          img: "https://www.woqu365.com/img/10.30db40f9.png",
        },
        {
          img: "https://www.woqu365.com/img/13.b5c6be01.png",
        },
        {
          img: "https://www.woqu365.com/img/14.fbfdd900.png",
        },
        {
          img: "https://www.woqu365.com/img/4.45a44bc0.png",
        },
        {
          img: "https://www.woqu365.com/img/3.7b174dd0.png",
        },
      ],
      optionSingleHeightTime: {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 0, // 单步运动停止的时间(默认值1000ms)},
      },
      part1List: [
        {
          img: "https://www.woqu365.com/img/image001.641e630f.png",
          title: "喔趣人效云UX全新升级",
          desc: "xxxxxxx",
        },
        {
          img: "https://www.woqu365.com/img/image004.e3035652.png",
          title: "后疫情时代企业用工管理的应对措施 ",
          desc: "xxxxxxx",
        },
        {
          img: "https://www.woqu365.com/img/image003.fd3406f3.png",
          title: "喔趣行业案例集—向人效去 ",
          desc: "xxxxxxx",
        },
        {
          img: "	https://www.woqu365.com/img/image005.aa988acc.png",
          title: "喔趣科技行业解决方案 ",
          desc: "xxxxxxx",
        },
      ],
      part3List: [
        {
          name: "建筑",
          info: {
            title: "建筑行业解决方案",
            desc:
              "建筑行业软件解决方案，提供全面的数字化工具和技术支持，帮助建筑师、工程师和施工团队实现高效、精准和协同的工作流程，从而提高项目质量和效率，降低成本和风险。",
            type: [],
            logo: [
              "https://www.woqu365.com/img/4-1-1.6f24c484.png",
              "https://www.woqu365.com/img/4-1-2.35a15496.png",
              "https://www.woqu365.com/img/4-1-6.ab1404b1.png",
            ],
          },
        },
        {
          name: "市政",
          info: {
            title: "市政行业解决方案",
            desc:
              "为城市管理和公共服务提供全面支持的软件系统，包括城市规划、公共事务、交通管理、环境保护等多个领域，通过数字化、智能化等技术手段，提高城市管理效率，优化公共服务水平，实现可持续发展目标。",
            type: [],
            logo: [
              "https://www.woqu365.com/img/4-2-1.9fcba3b0.png",
              "https://www.woqu365.com/img/4-2-3.6194a3a6.png",
              "https://www.woqu365.com/img/4-2-6.95eb1d76.png",
            ],
          },
        },
        {
          name: "公路",
          info: {
            title: "公路行业解决方案",
            desc:
              "全面的公路行业软件解决方案，提升效率、降低成本、优化管理，实现数字化转型。",
            type: [],
            logo: [
              "https://www.woqu365.com/img/4-3-1.a9e6e720.png",
              "https://www.woqu365.com/img/4-3-3.c6942a28.png",
              "https://www.woqu365.com/img/4-3-6.cd232823.png",
            ],
          },
        },
        {
          name: "铁路",
          info: {
            title: "铁路行业解决方案",
            desc:
              "全面的铁路行业软件解决方案，涵盖各个领域，提高效率，降低成本，实现数字化转型。",
            type: [],
            logo: [
              "https://www.woqu365.com/img/4-4-1.00c4f80d.png",
              "https://www.woqu365.com/img/4-4-2.b195955f.png",
              "https://www.woqu365.com/img/4-4-4.d1a300c0.png",
            ],
          },
        },
      ],
      part3Index: 0,
      part5List: [
        {
          img: "https://www.woqu365.com/img/customer007.63ad3af6.png",
          desc:
            "e勘察使得勘察人员可以更加便捷地进行勘察工作，减少了不必要的人力和时间成本。",
          tip: "xxxxxxxxxxxx集团",
          top: "-12px",
          left: "100px",
        },
        {
          img: "https://www.woqu365.com/img/customer002.8f69836a.png",
          desc:
            "使用e勘察，我们可以更好地管理和维护勘察数据，避免了数据丢失和混淆的问题。",
          tip: "xxxxxxxxxxxx集团",
          top: "240px",
          left: "78px",
        },
        {
          img: "https://www.woqu365.com/img/customer003.ba60509f.png",
          desc:
            "e勘察的数据可视化和分析功能，让我们更加全面地了解勘察数据，为决策提供了有力的支持。",
          tip: "xxxxxxxxxxxx集团",
          top: "120px",
          left: "152px",
        },
        {
          img: "https://www.woqu365.com/img/customer004.7cc57488.png",
          desc:
            "ytkc软件可以快速进行概预算、工作量统计、土层统计、试验指标统计等，避免了手动计算和处理数据的繁琐过程，大大提高了工作效率。",
          tip: "xxxxxxxxxxxx集团",
          top: "250px",
          left: "230px",
        },
        {
          img: "https://www.woqu365.com/img/customer005.80e43d0e.png",
          desc:
            "数字服务平台使整个项目的跟进与整改都非常及时，这对我们客户而言是非常需要的，因为如果问题不及时解决，就会影响到后续的工作。我觉得双方合作都是朝着共赢的方向走的，也希望勘察服务平台未来能发展地越来越好。",
          tip: "xxxxxxxxxxxx集团",
          top: "12px",
          left: "296px",
        },
        {
          img: "https://www.woqu365.com/img/customer006.7124a8ae.png",
          desc:
            "ytkc软件的计算结果基于科学的算法和模型，可以为工程设计和施工提供科学依据和参考，提高工程质量和安全性。",
          tip: "xxxxxxxxxxxx集团",
          top: "159px",
          left: "357px",
        },
        {
          img: "https://www.woqu365.com/img/customer001.06faffb2.png",
          desc:
            "数字化可以提高企业的生产效率、降低成本、拓展市场、提升客户体验、加强数据管理等，帮助企业更加灵活、高效地应对市场变化和竞争压力。",
          tip: "xxxxxxxxxxxx集团",
          top: "370px",
          left: "330px",
        },
        {
          img: "https://www.woqu365.com/img/customer008.d9ba401b.png",
          desc:
            "只有依托数字化驱动企业管理变革，才能有效的提升企业的整体运营效率和决策的准确性，为战略落地保驾护航。",
          tip: "xxxxxxxxxxxx集团",
          top: "281px",
          left: "450px",
        },
        {
          img: "https://www.woqu365.com/img/customer009.adafbfb2.png",
          desc:
            "使用数字勘察服务平台，不仅大大缩短了勘察时间，还能够减少人力成本，提高勘察效率，降低错误率，提供更为准确的数据分析和报告，帮助企业更好地做出决策，增强市场竞争力。",
          tip: "xxxxxxxxxxxx集团",
          top: "-43px",
          left: "444px",
        },
        {
          img: "https://www.woqu365.com/img/customer010.4c5578c9.png",
          desc:
            "数字勘察服务平台的团队非常认真负责，会竭尽全力确保每项服务都能够达到客户的期望值，并且能够满足其需求。",
          tip: "xxxxxxxxxxxx集团",
          top: "118px",
          left: "530px",
        },
        {
          img: "https://www.woqu365.com/img/customer011.cefb0f1a.png",
          desc:
            "选择数字勘察服务平台不仅是因为产品本身的匹配度，而是因为大家的价值观从本质上都是‘以客户’为核心”。正因为共同的理念，让我们走到了一起。",
          tip: "xxxxxxxxxxxx集团",
          top: "402px",
          left: "510px",
        },
        {
          img: "https://www.woqu365.com/img/customer012.cd941ff1.png",
          desc:
            "数字勘察服务平台整体的灵活性比较强，除此之外，能够快速响应客户需求，提供个性化的服务。",
          tip: "xxxxxxxxxxxx集团",
          top: "385px",
          left: "150px",
        },
      ],
      part5Index: 0,
      newsList: [
        {
          img: "https://img.woqukaoqin.com/i/sys/11/35/16/6ad20956614148b5.jpg",
          title: "报名 | 闭门分享会：HR数字化应用现状、发展与趋势是什么？",
          desc: "5月25日，期待你的报名！",
        },
        {
          img: "https://img.woqukaoqin.com/i/sys/11/24/78/0878c22291bb45f8.jpg",
          title: "喔趣科技蝉联HRoot「2022年度最佳人力资源服务机构」榜单",
          desc: "喔趣科技，成就数字化人效",
        },
        {
          img: "https://img.woqukaoqin.com/i/sys/11/21/00/75aa708e99f44292.jpg",
          title: "喔趣科技亮相第十三届中国轻工业信息化大会，助力制造变革",
          desc: "喔趣科技，成就数字化人效",
        },
        {
          img: "https://img.woqukaoqin.com/i/sys/11/08/41/2a7a65a2d32a4ed6.jpg",
          title: "喔趣科技蝉联“2023 SaaS企业TOP100”榜单",
          desc: "喔趣科技，成就数字化人效",
        },
      ],
      lastSpaceTime: 0, // 上一次按下空格键的时间戳
    };
  },
  methods: {
    handleKeyDown(event) {
      if (event.keyCode === 32) {
        // 空格键的 keyCode 是 32
        const currentTime = new Date().getTime();
        if (currentTime - this.lastSpaceTime < 300) {
          // 如果两次按下空格键的时间间隔小于 300 毫秒，则执行双击事件
          this.doubleClick();
        }
        this.lastSpaceTime = currentTime;
      }
    },
    pushApplication() {
      this.$router.push("/application");
    },
    addPart5Index() {
      if (this.part5Index == this.part5List.length - 1) {
        this.part5Index = 0;
      } else {
        this.part5Index++;
      }
    },
    cutPart5Index() {
      if (this.part5Index == 0) {
        this.part5Index = this.part5List.length - 1;
      } else {
        this.part5Index--;
      }
    },
  },
  computed: {},
  mounted() {

  
  },
};
</script>

<style lang="scss" scoped>
img {
  user-select: none !important;
}
.top-banner {
  background-image: url("../assets/banner/1.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 500px;
  width: 100%;
  // margin-top: 76px;
  padding-top: 140px;
  text-align: left;
  position: relative;
  &-title {
    font-size: 48px;
    color: rgb(6, 73, 215);
    letter-spacing: 0;
    line-height: 72px;
    font-weight: 600;
    text-align: left;
    margin-left: 180px;
    position: absolute;
    top: 30%;
    left: 9.7%;
  }
  &-content {
    opacity: 0.8;
    font-size: 27px;
    color: rgb(6, 73, 215);
    letter-spacing: 0;
    line-height: 36px;
    margin-top: 20px;
    text-align: left;
    margin-left: 180px;
    position: absolute;
    top: 46%;
    left: 9.7%;
  }
  &-btn {
    display: inline-block;
    margin-top: 70px;
    border-radius: 20px;
    width: 178px;
    height: 40px;
    margin-right: 30px;
    color: white;
    font-size: 14px;
    letter-spacing: 0;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    background-image: linear-gradient(135deg, #1cffcd 0%, #2347ff 100%);
    margin-left: 180px;
    position: absolute;
    top: 62%;
    left: 9.7%;
    transition: all 0.3s;
    &:hover {
      background-image: linear-gradient(135deg, #00ffc8 0%, #002aff 100%);
    }
  }
}
.bannerBox {
  width: 1280px;
  margin: 26px auto 64px;
  position: relative;
  overflow: hidden;
  &::before {
    content: "";
    width: 300px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(270deg, hsla(0, 0%, 100%, 0), #fff);
    z-index: 999;
  }
  &::after {
    content: "";
    width: 300px;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(90deg, hsla(0, 0%, 100%, 0), #fff);
    z-index: 999;
  }
  .list {
    width: 1010px;
    height: 58px;
    .item {
      display: inline-block;
      width: 144px;
      height: 58px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.part1 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .item {
    width: 304px;
    height: 242px;
    background: #fff;
    box-shadow: 0 4px 28px 0 hsl(0deg 0% 87% / 50%);
    border-radius: 8px;
    transition: all 0.5s;
    overflow: hidden;
    &:hover {
      transform: scale(1.04);
      .title {
        color: #000;
      }
    }
    img {
      flex: 1;
      width: 100%;
    }
    .info {
      width: 100%;
      height: 70px;
      .title {
        margin: 16px 0 0 18px;
        font-size: 16px;
        font-weight: 500;
        color: #181818;
        line-height: 18px;
      }
      .desc {
        margin: 8px 0 0 18px;
        height: 20px;
        font-size: 12px;
        font-weight: light;
        color: #888c96;
        line-height: 15px;
        cursor: pointer;
      }
    }
  }
}
.part2 {
  width: 100%;
  // margin-top: 88px;
  background: rgba(51, 51, 51, 0.02);
  padding: 72px 0;
  .container-part2 {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: auto !important;
    img {
      width: 600px;
      margin-right: 60px;
    }
    .right {
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 50px;
      > .title {
        font-size: 32px;
        font-weight: 600;
        color: #13203a;
        line-height: 45px;
      }
      .desc {
        color: #888c96;
        margin-top: 60px;
        display: grid;
        grid-template-columns: 400px 400px;
        column-gap: 30px;
        row-gap: 40px;
        .item {
          height: 110px;
          border-radius: 12px;
          background-color: #fff;
          box-shadow: 1px 1px 5px 5px hsl(0deg 0% 80% / 10%);
          cursor: pointer;
          transition: all 0.2s ease-in;
          padding: 15px 24px 18px;
          &:hover {
            transform: scale(1.05) translateY(-12px);
            box-shadow: 1px 1px 5px 5px hsl(0deg 0% 80% / 30%);
            background-image: linear-gradient(to bottom, #769bff, #386ffa);
            .title,
            .content {
              color: #fff !important;
            }
          }
          .title {
            font-size: 18px;
            color: transparent;
            font-weight: 600;
            text-align: center;
            margin-bottom: 10px;
            transition: all 0.3s;
            background-image: linear-gradient(to right, #a2bafd, #1455fc);
            background-clip: text;
          }
          .content {
            font-size: 14px;
            color: #555;
            text-align: justify;
            line-height: 1.6;
            transition: all 0.3s;
          }
        }
      }
      .btn {
        width: 341px;
        height: 48px;
        line-height: 48px;
        margin-top: 40px;
        background: #fff;
        color: #1678ff;
        border: 1px solid #1678ff;
        border-radius: 4px;
        font-size: 16px;
        cursor: pointer;
        &:hover {
          color: #fff;
          background: #1678ff;
        }
      }
    }
  }
}
.part3 {
  width: 100%;
  padding: 70px 0 110px 0;
  .title {
    font-size: 32px;
    font-weight: 700;
    color: #13203a;
    line-height: 45px;
    text-align: center;
  }
  .tabBox {
    display: flex;
    justify-content: space-between;
    margin-top: 64px;
    .tabs {
      width: 228px;
      height: auto;
      border-radius: 4px;
      margin-right: 49px;
      .tab {
        width: 228px;
        height: 56px;
        text-align: center;
        line-height: 56px;
        color: #13203a;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        border: 1px solid #e7e7e7;
        & + .tab {
          border-top: none;
        }
        &:first-of-type {
          border-radius: 4px 4px 0 0;
        }
        &:last-of-type {
          border-radius: 0 0 4px 4px;
        }
        &.active {
          color: #fff;
          background-color: #1678ff;
          border-radius: 4px;
        }
      }
    }
    .info {
      padding-left: 47px;
      position: relative;
      &::before {
        content: "";
        width: 2px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: #e7e7e7;
      }
      .title {
        font-size: 24px;
        font-weight: 700;
        color: #13203a;
        line-height: 33px;
        text-align: left;
      }
      .desc {
        margin-top: 12px;
        width: 960px;
        font-size: 16px;
        font-weight: 400;
        color: #888c96;
        line-height: 28px;
      }
      .btnBox {
        display: flex;
        margin-top: 24px;
        .btn {
          width: 160px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          cursor: pointer;
          border-radius: 4px;
        }
        .btn:first-of-type {
          color: #fff;
          border: 1px solid #1678ff;
          background: #1678ff;
        }
        .btn:last-of-type {
          color: #1678ff;
          border: 1px solid #1678ff;
          background: #fff;
          margin-left: 20px;
        }
      }
      .typeBox {
        display: flex;
        align-items: center;
        margin-top: 25px;
        .type {
          width: 104px;
          height: 30px;
          border: 1px solid hsla(0, 0%, 59.2%, 0.5);
          border-radius: 3px;
          font-size: 14px;
          font-weight: 500;
          color: #333330;
          display: flex;
          justify-content: center;
          align-items: center;
          & + .type {
            margin-left: 12px;
          }
        }
        .dashed {
          flex: 1;
          height: 1px;
          border-top: 3px dotted #e7e7e7;
          margin-left: 10px;
        }
      }
      .logoBox {
        display: flex;
        align-items: center;
        .logo {
          width: 150px;
          height: 79px;
        }
      }
    }
  }
}
.part4 {
  background-color: #1678ff;
  text-align: center;
  padding: 72px 0;
  .title {
    color: #fff;
    line-height: 45px;
    font-size: 32px;
    text-align: center;
  }
  .phone {
    font-size: 24px;
    line-height: 40px;
    color: #fff;
    margin: 16px 0 24px 0;
  }
  .input {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48px;
    input {
      width: 420px;
      height: 100%;
      line-height: 48px;
      padding-left: 16px;
      background: #fff;
      border: none;
      outline: none;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    .appoint {
      width: 135px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      color: #fff;
      font-weight: 700;
      cursor: pointer;
      background: #38c0ff;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
  .tip {
    line-height: 20px;
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    margin-top: 24px;
  }
}
.part5 {
  background-color: #f7f8fa;
  padding-top: 80px;
  padding-bottom: 130px;
  .title {
    font-size: 32px;
    font-weight: 700;
    color: #13203a;
    line-height: 51px;
    text-align: center;
  }
  .sub-title {
    color: #666;
    font-size: 20px;
    margin-top: 12px;
    text-align: center;
    span {
      color: #007aff;
    }
  }
  .content {
    width: 100%;
    height: 472px;
    margin-top: 65px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .tabBox {
      width: 584px;
      height: 334px;
      background-color: #fff;
      box-shadow: 0 6px 32px 0 hsl(0deg 0% 87% / 50%);
      position: relative;
      padding: 75px 40px 30px 40px;
      margin-right: 60px;
      .prev {
        position: absolute;
        top: -57px;
        right: 67px;
        width: 40px;
        height: 40px;
        border-radius: 34px;
        border: 2px solid #1678ff;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
        }
      }
      .next {
        position: absolute;
        top: -57px;
        right: 10px;
        width: 40px;
        height: 40px;
        border-radius: 34px;
        border: 2px solid #1678ff;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
        }
      }
      .logoBox {
        position: absolute;
        left: 40px;
        top: -52px;
        width: 104px;
        height: 104px;
        border-radius: 52px;
        text-align: center;
        padding: 3px;
        box-sizing: border-box;
        background-image: linear-gradient(180deg, #1678ff, #31d2ff);
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 98px;
          height: 98px;
          border-radius: 50%;
          background-color: #fff;
        }
      }
      .desc {
        width: 504px;
        font-size: 16px;
        font-weight: 400;
        color: #13203a;
        line-height: 32px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
      }
      .tip {
        float: right;
        text-align: right;
        margin-top: 16px;
        line-height: 32px;
        font-weight: 700;
        position: relative;
        &::before {
          content: "";
          width: 40px;
          height: 1px;
          border-top: 1px solid #d3d3d3;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -52px;
        }
      }
      .btn {
        width: 136px;
        height: 40px;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 40px;
        border-radius: 4px;
        position: absolute;
        cursor: pointer;
      }
      .apply {
        color: #fff;
        background: #1678ff;
        border: 2px solid #1678ff;
        bottom: 30px;
        left: 40px;
      }
      .get {
        color: #1678ff;
        border: 2px solid #1678ff;
        bottom: 30px;
        left: 200px;
      }
      &::before {
        content: "“";
        position: absolute;
        top: -135px;
        left: 0;
        font-size: 120px;
        color: #c4eaff;
      }
      &::after {
        content: "”";
        position: absolute;
        right: 0;
        bottom: -135px;
        font-size: 120px;
        color: #c4eaff;
      }
    }
    .view {
      flex: 1;
      height: 100%;
      position: relative;
      .item {
        position: absolute;
        width: 104px;
        height: 104px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        overflow: hidden;
        transition: all 0.5s;
        &.active {
          background-image: linear-gradient(180deg, #1678ff, #31d2ff);
          transform: scale(1.05);
        }
        img {
          width: 98px;
          height: 98px;
          border-radius: 50%;
          background: #fff;
          transition: all 0.5s;
        }
      }
    }
  }
}
.part6 {
  padding: 80px 0 112px 0;
  & > .title {
    text-align: center;
    font-size: 32px;
    font-weight: 600;
    color: #13203a;
    line-height: 45px;
  }
  .newsBox {
    margin-top: 72px;
    display: flex;
    .main-news {
      width: 592px;
      height: 506px;
      display: flex;
      flex-direction: column;
      margin-right: 58px;
      img {
        width: 100%;
        height: 416px;
      }
      & > .title {
        flex: 1;
        width: 100%;
        padding-left: 20px;
        box-shadow: 0 4px 32px 0 hsl(0deg 0% 87% / 30%);
        color: #13203a;
        font-size: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        line-height: 90px;
        font-weight: 700;
        cursor: pointer;
        &:hover {
          color: #1678ff;
          text-decoration: underline;
        }
      }
    }
    .news-list {
      width: 638px;
      height: 506px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .item {
        display: flex;
        border-radius: 4px;
        box-shadow: 0 4px 32px 0 hsl(0deg 0% 87% / 30%);
        cursor: pointer;
        transition: all 0.5s;
        &:hover {
          transform: scale(1.04);
          .title {
            text-decoration: underline;
            color: #1678ff !important;
          }
        }
        img {
          width: 150px;
          height: 110px;
          border-radius: 4px;
        }
        .info {
          flex: 1;
          padding: 18px 28px;
          .title {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            font-size: 18px;
            font-weight: 500;
            color: #13203a;
            line-height: 25px;
          }
          .desc {
            margin-top: 12px;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: #888c96;
            line-height: 20px;
          }
        }
      }
    }
  }
}
</style>
